import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import DrawerPageInfo from './components/DrawerPageInfo';
import { getRouteSupport } from './getRouteSupport';

interface PageInfoProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const PageInfo = ({ open, onOpenChange }: PageInfoProps) => {
  const { sidebar } = useDashboard();
  const support = getRouteSupport(sidebar);

  if (!support?.uid) return null;

  return <DrawerPageInfo supportUID={support.uid} relationUIDs={support.relations} open={open} onOpenChange={onOpenChange} />;
};
export default PageInfo;
